import { Component, OnInit } from '@angular/core';
import { AccountSummary, AuthStoreService, UserSettings } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { BusinessRuleMessage } from 'src/app/core/model/core/business-rule-message';
import { User } from 'src/app/core/model/user';
import { UserStoreService } from 'src/app/core/store/user-store.service';

@UntilDestroy()
@Component({
  selector: 'app-account-summary-widget',
  templateUrl: './account-summary-widget.component.html',
  styleUrls: ['./account-summary-widget.component.scss'],
})
export class AccountSummaryWidgetComponent implements OnInit {
  currentYear = new Date().getFullYear();

  accountSummary: AccountSummary | undefined;
  currentYearAccountSummary: AccountSummary | undefined;
  pastYearAccountSummary: AccountSummary | undefined;
  isJapan: boolean;
  businessRules: BusinessRuleMessage[];

  constructor(private userStore: UserStoreService, private authStore: AuthStoreService) {}

  ngOnInit(): void {
    this.userStore.getBusinessRules();

    this.userStore.accountSummary$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((accountSummary) => {
      this.accountSummary = accountSummary;
    });

    this.userStore.yearAccountSummaries$
      .pipe(untilDestroyed(this), filter(Boolean))
      .subscribe((yearAccountSummaries) => {
        const currentYearAccountSummary = yearAccountSummaries.find(
          (yearAccountSummary) => yearAccountSummary.programYear === this.currentYear
        );

        if (currentYearAccountSummary) {
          this.currentYearAccountSummary = currentYearAccountSummary;
        }

        const pastYearAccountSummary = yearAccountSummaries.find(
          (yearAccountSummary) => yearAccountSummary.programYear === this.currentYear - 1
        );

        if (pastYearAccountSummary) {
          this.pastYearAccountSummary = pastYearAccountSummary;
        }
      });

    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((userSettings) => {
      if (userSettings.user != null) {
        const { country } = this.authStore.userSettings as UserSettings<User>;
        if (country) {
          this.isJapan = country.alpha2Code === 'JP';
        }
      }
    });

    this.userStore.businessRules$.pipe(filter(Boolean), untilDestroyed(this)).subscribe((businessRules) => {
      this.businessRules = businessRules;
    });
  }
}
